import React, { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import Iframe from './Iframe';
// import Zoomin from './Zoomin'
// import { saveAs } from 'file-saver';
// import { UserContext } from '../../shared/context/UserContext';

const IframeWithZoomWrapper = styled.button`
    display: flex;
    flex-direction: row;
    border: none;
    background-color: white;
`

function IframeWithZoom(props) {

  const [zoom, setZoom] = useState(1);
  const [rotate, setRotate] = useState(0);
  // console.log(typeof(zoom));
  // console.log(typeof(rotate));
  function handleOnClickZoomIn(x) {
    setZoom(x);
    console.log(zoom);
    // console.log(typeof(zoom));
    // console.log(typeof(rotate));
  }

  function handleOnClickZoomOut(x) {
    setZoom(x);
    console.log(zoom);
  }

  function handleOnClickRotateLeft(x) {
    setRotate(x);
    console.log(rotate);
  }

  function handleOnClickRotateRight(x) {
    setRotate(x);
    console.log(rotate);
  }

//   function handleonClickDownload() {
//     // saveAs(props.image, "image.jpg");
//     fetch(props.image).then(response => {
//       response.blob().then(blob => {
//         // Creating new object of PDF file
//         const fileURL = window.URL.createObjectURL(blob);
//         // Setting various property values
//         let alink = document.createElement('a');
//         alink.href = fileURL;
//         alink.download = 'DocumentPDF.pdf';
//         alink.click();
//       })
//     })
//   }

  return (
    <IframeWithZoomWrapper>
      <Iframe image={props.image} theme={props.theme} zoom={zoom} rotate={rotate} />
    </IframeWithZoomWrapper>
  )
}

export default IframeWithZoom